import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { AdminFormValues } from "src/models/User.model";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import AdminForm from "../Layouts/AdminForm";
import {
  useGetSingleAdminQuery,
  useUpdateAdminMutation,
} from "src/services/AuthServices";

type Props = {
  onClose: () => void;
  userId: string;
};

const EditAdminFormWrapper = ({ onClose, userId }: Props) => {
  const [userData, setUserData] = useState<any>({});
  const [updateUser] = useUpdateAdminMutation();

  // Form Initial Values
  const initialValues: AdminFormValues = {
    name: userData?.name,
    email: userData?.email,
    mobile: userData?.mobile,
    roleId: { label: userData?.roleName, value: userData?.roleId },
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    email: string().email().required("Please enter email"),
    mobile: string()
      .required("Please enter mobile number")
      .matches(/^[0-9]{10}$/, {
        message: "Mobile number should contain exactly 10 digits.",
      }),
    roleId: object().required("Please select role"),
  });
  const { data, isLoading, isFetching } = useGetSingleAdminQuery({
    id: userId,
  });
  useEffect(() => {
    if (!isFetching && !isLoading) {
      setUserData(data?.data);
    }
  }, [data, isFetching, isLoading]);
  // Handle Submit
  const handleSubmit = (
    values: AdminFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AdminFormValues>
  ) => {
    const formatedValues = {
      name: values?.name,
      mobile: values?.mobile,
      email: values?.email,
      roleId: values?.roleId.value,
    };
    updateUser({ id: userId, body: formatedValues }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <AdminForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditAdminFormWrapper;
